/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Cmp_Meta_DescInputs */

const en_cmp_meta_desc = /** @type {(inputs: Cmp_Meta_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`How Bystep compares to ${i?.name}: feature matrix, pricing, and when to choose ${i?.name} instead.`)
};

const id_cmp_meta_desc = /** @type {(inputs: Cmp_Meta_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Perbandingan Bystep dan ${i?.name}: matriks fitur, harga, dan kapan sebaiknya memilih ${i?.name}.`)
};

/**
* | output |
* | --- |
* | "How Bystep compares to {name}: feature matrix, pricing, and when to choose {name} instead." |
*
* @param {Cmp_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cmp_meta_desc = /** @type {((inputs: Cmp_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmp_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cmp_meta_desc(inputs)
	return en_cmp_meta_desc(inputs)
});